import * as ViewModel from '@/core/presenter/viewModel';
import TrxTransactionItem from './TrxTransactionItem';
import NoActivityData from './NoActivityData';
import { MAX_TRANSACTION_ITEMS } from '@/consts';
import { observer } from 'mobx-react-lite';
import ActivityItemInfo from './ActivityItemInfo';
import {
  ALERT_ICON_PATH,
  ASSET_RESET_ICON_PATH,
  BACK_ICON_PATH,
  T_LOGO_ICON_PATH,
  TRX_SYMBOL_ICON_PATH,
} from '@/consts/imgPath';

interface IProps {
  trxTransactions: ViewModel.IResponseActivity[];
  trxBalance: string;
  trxKrw: string;
  trxPrice: number;
  onClickBackBtn: () => void;
  onClickResetBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
  onResetSelectedAsset: () => void;
  onClickPrevTransactionBtn: () => void;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TrxView = observer(
  ({
    trxTransactions,
    trxBalance,
    trxKrw,
    onClickBackBtn,
    onClickResetBtn,
    onClickViewType,
    onResetSelectedAsset,
    onClickPrevTransactionBtn,
    onClickCopyBtn,
  }: IProps) => {
    const handleClickSendBtn = () => {
      onResetSelectedAsset();
      onClickViewType(ViewModel.HomeViewType.SEND);
    };

    return (
      <div className="container">
        <header className="ili-header sticky-header">
          <a href="#" className="back-area" onClick={onClickBackBtn}>
            <img src={BACK_ICON_PATH} alt="back-icon" />
          </a>
          <a className="inner">
            <div className="img">
              <img src={T_LOGO_ICON_PATH} alt="Logo" />
            </div>
            <h1>Takk</h1>
          </a>
          <div className="icon-area">
            <img src={ALERT_ICON_PATH} alt="alert-icon" style={{ opacity: 0 }} />
          </div>
        </header>
        <div className="card-ui">
          <div className="icon-ss">
            <img src={TRX_SYMBOL_ICON_PATH} alt="Icon" />
            <h2>트론</h2>
            <span className="mn-gray fw-n body-xs">TRX</span>
          </div>
          <div className="total-amount fw-n">
            <h3 className="total-balance">{trxBalance} TRX</h3>
            <a href="#" className="right" onClick={onClickResetBtn}>
              <img src={ASSET_RESET_ICON_PATH} alt="reset-icon" />
            </a>
          </div>
          <div className="exchange body-xl ml-gray">{trxKrw} 원</div>
          <div className="button-group">
            <button className="solid" onClick={handleClickSendBtn}>
              보내기
            </button>
            <button className="solid" onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}>
              받기
            </button>
          </div>
        </div>
        {trxTransactions.length === 0 && <NoActivityData />}
        {trxTransactions.length > 0 && (
          <div className="activity-area-ss">
            <ul className="list">
              {trxTransactions.slice(0, MAX_TRANSACTION_ITEMS).map((trxTransaction, index) => (
                <TrxTransactionItem trxTransaction={trxTransaction} key={index} onClickCopyBtn={onClickCopyBtn} />
              ))}
              <ActivityItemInfo onClickPrevTransactionBtn={onClickPrevTransactionBtn} />
            </ul>
          </div>
        )}
      </div>
    );
  },
);

export default TrxView;
